declare global {
  interface Window {
    hj?: (command: string, ...args: unknown[]) => void;
  }
}

export function loadHotjar() {
  const tagUrl = process.env.REACT_APP_HOTJAR_TAG_URL;

  if (!tagUrl) {
    console.warn('Hotjar tag missing (REACT_APP_HOTJAR_TAG_URL not set)');
    return;
  }

  // Prevent script duplication
  if (document.querySelector(`script[src="${tagUrl}"]`)) {
    console.log('Hotjar script already loaded:', tagUrl);
    return;
  }

  const script = document.createElement('script');
  script.src = tagUrl;
  script.async = true;
  script.defer = true;

  document.head.appendChild(script);
  console.log('Hotjar tag loaded:', tagUrl);
}

/**
 * Notify Hotjar of a client-side route change (SPA navigation).
 * Call this whenever the URL changes without a full page reload so Hotjar
 * funnels, heatmaps, and recordings recognize the new page.
 * @param virtualPath - Path to record (e.g. pathname + search, or full virtual URL)
 */
export function triggerHotjarStateChange(virtualPath: string): void {
  if (typeof window === 'undefined' || !window.hj) return;
  try {
    window.hj('stateChange', virtualPath);
    console.log('[Hotjar] stateChange:', virtualPath);
  } catch {
    // Hotjar not ready or failed
  }
}
